<template>
    <div class="device-type-add">
        <el-page-header @back="goBack" content="编辑配置"></el-page-header>
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="180px" class="form"
                 style="width: 40%;margin: 20px auto 0 auto;" autocomplete="off">
            <el-form-item label="服务器名称" prop="site_name">
                <el-input type="text" v-model="ruleForm.site_name" placeholder="请输入服务器名称" autocomplete="off"
                          style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="服务器地址" prop="site_url">
                <el-input type="text" v-model="ruleForm.site_url" placeholder="请输入服务器地址" autocomplete="off"
                          style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="接口地址" prop="api_url">
                <el-input type="text" v-model="ruleForm.api_url" placeholder="请输入接口地址" autocomplete="off"
                          style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="图片地址" prop="img_prefix_url">
                <el-input type="text" v-model="ruleForm.img_prefix_url" placeholder="请输入图片地址" autocomplete="off"
                          style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="IM链接地址" prop="im_socket_url">
                <el-input type="text" v-model="ruleForm.im_socket_url" placeholder="请输入IM链接地址" autocomplete="off"
                          style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="IM SSL链接地址" prop="im_socket_ssl_url">
                <el-input type="text" v-model="ruleForm.im_socket_ssl_url" placeholder="请输入IM SSL链接地址" autocomplete="off"
                          style="width: 100%;"></el-input>
            </el-form-item>


            <!-- form表单提交 -->
            <el-form-item>
                <el-button @click="goBack">取消</el-button>
                <el-button type="success" @click="submitForm('ruleForm')">保存</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
    import {check} from "@/utils/checkData";

    export default {
        mounted() {
            this.ruleForm.id = this.$route.params.id;
            this.ruleForm.site_name = this.$route.params.site_name;
            this.ruleForm.site_url = this.$route.params.site_url;
            this.ruleForm.api_url = this.$route.params.api_url;
            this.ruleForm.img_prefix_url = this.$route.params.img_prefix_url;
            this.ruleForm.im_socket_url = this.$route.params.im_socket_url;
            this.ruleForm.im_socket_ssl_url = this.$route.params.im_socket_ssl_url;
        },
        data() {
            return {
                ruleForm: {
                    id:'',
                    site_name: "",
                    site_url: "",
                    api_url: "",
                    img_prefix_url: "",
                    im_socket_url: "",
                    im_socket_ssl_url: "",
                },
                rules: {
                    site_name: [
                        {required: true, message: "请输入服务器名称", trigger: "blur"},
                    ],
                    site_url: [
                        {required: true, message: "请输入服务器地址", trigger: "blur"},
                    ],
                    api_url: [
                        {required: true, message: "请输入接口地址", trigger: "blur"},
                    ],
                    img_prefix_url: [
                        {required: true, message: "请输入图片地址", trigger: "blur"},
                    ],
                    im_socket_url: [
                        {required: true, message: "请输入IM链接地址", trigger: "blur"},
                    ],
                },
                is_submit: false,
            };
        },
        methods: {
            // 返回上一页
            goBack() {
                window.history.go(-1);
            },

            // 提交表单
            submitForm(formName) {
                if (this.is_submit) {
                    // 重复提交提醒
                    this.$message({
                        type: "warning",
                        message: '正在处理请求，请不要重复提交',
                        duration: 1500,
                    });
                    return;
                }
                this.is_submit = true;
                let _that = this
                this.$refs[formName].validate(valid => {
                    if (valid) {
                        let params = {
                            'servername': 'Ruyi_AdminSystemServices',
                            'method': 'editServer',
                            'params': this.ruleForm
                        };
                        this.$api.service(params).then(res => {
                            if (!check(res)) {
                                this.is_submit = false;
                                return;
                            }
                            this.$message({
                                type: "success",
                                message: '编辑成功',
                                duration: 1500,
                                onClose: function () {
                                    _that.is_submit = false;
                                    window.history.go(-1);
                                }
                            });
                        }).catch(() => {
                            this.is_submit = false;
                        }).finally(() => {
                            this.is_submit = false;
                        });
                    } else {
                        this.$message({
                            type: "error",
                            message: '请输入必填项'
                        });
                        this.is_submit = false;
                        return false;
                    }
                });
                this.is_submit = false;
            },
        }

    };
</script>
<style lang="scss">
    @import "@/styles/common.scss";

    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }

    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }

    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 50px;
        height: 50px;
        line-height: 50px;
        text-align: center;
    }

    .avatar {
        width: 50px;
        height: 50px;
        display: block;
    }
</style>
